import {
    apiRequest,
    skpensiunDetail
} from "../../../../../services/adapters/kepegawaian/skpensiunService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", skpensiunDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository